import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { AiLogoSize } from './ai-logo.types';

@Component({
  selector: 'rt-ai-logo',
  templateUrl: './ai-logo.component.html',
  styleUrls: ['./ai-logo.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'size',
  },
  standalone: true,
})
export class AiLogoComponent {
  @Input() public size: AiLogoSize = 'base';
}
